import createPersistedState from 'use-persisted-state';

export const useHasAccountState = createPersistedState('hasAccount');
export const useEmailState = createPersistedState('email');
